import { Watchlist } from "../widgets/Watchlist";

/** Mobile Markets (Tradesea): the watchlist; tapping a symbol retargets the red link group used by Trade. */
export function Markets(): React.JSX.Element {
  return (
    <div className="m-markets m-card m-card-flush">
      <Watchlist link="red" />
    </div>
  );
}
